const CurrencyFormat = ({num}) => {
    // return num == null ? 0 : num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return num == null || num === 0 ? '' : num.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};

export default CurrencyFormat;